import { LockOutlined } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"

const AccessRestricted = () => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            bgcolor="background.default"
        >
            <LockOutlined sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
            <Typography variant="h4" component="h1" gutterBottom>
                Access Denied
            </Typography>
            <Typography variant="body1" align="center" sx={{ mb: 4 }}>
                Sorry, you do not have permission to access this page.
            </Typography>
        </Box>
    )
}


export default AccessRestricted
